import React, { forwardRef, useContext } from 'react';
import buttonStyles from './styles';
import { useLinkBuilder } from '../../hooks/useLinkBuilder';
import PageContext from '../../contexts/pageContext';

const Button = forwardRef(function Button(
  {
    fluid,
    disabled,
    data,
    styling,
    type,
    size,
    active,
    onClick,
    ...elementProps
  },
  ref
) {
  const { isEdit } = useContext(PageContext);
  const link = useLinkBuilder(data);
  const classes = buttonStyles({ fluid, disabled });
  return data?.isLink ? (
    <a
      ref={ref}
      href={link}
      target={data?.isExternal ? '_blank' : null}
      rel={data?.isExternal ? 'nofollow noopener' : null}
      className={
        (active ? classes.active : '') +
        ' ' +
        classes[type] +
        ' ' +
        classes[size] +
        ' ' +
        classes.anchorClass
      }
      style={styling}
      {...elementProps}
    >
      {data?.value}
    </a>
  ) : (
    <button
      ref={ref}
      className={
        (active ? classes.active : '') +
        ' ' +
        classes[type] +
        ' ' +
        classes[size]
      }
      onClick={isEdit ? null : onClick}
      style={styling}
      {...elementProps}
      disabled={disabled}
    >
      <span
        dangerouslySetInnerHTML={{
          __html: data?.value
        }}
      ></span>
    </button>
  );
});

export default Button;
